// extracted by mini-css-extract-plugin
export default {"row":"row_row__oZIhl","col":"row_col__jioOe","item":"row_item__d8WTi","pills":"row_pills__AoMgC","green":"row_green__plX2C","red":"row_red__84aO7","blue":"row_blue__7JhoC"};